import { useState, useEffect } from 'react';
import type { CampImage } from '../types/database';

interface RotatingCampImagesProps {
  images?: CampImage[];
  className?: string;
}

export default function RotatingCampImages({ images = [], className = '' }: RotatingCampImagesProps) {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (images.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentIndex((current) => (current + 1) % images.length);
    }, 5000); // Change image every 5 seconds

    return () => clearInterval(interval);
  }, [images.length]);

  if (!Array.isArray(images) || images.length === 0) return null;

  return (
    <div className={`relative ${className}`}>
      {images.map((image, index) => (
        <img
          key={image.id}
          src={image.url}
          alt={image.alt_text || 'Camp activity'}
          className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-1000 ${
            index === currentIndex ? 'opacity-100' : 'opacity-0'
          }`}
        />
      ))}
    </div>
  );
}